import Breadcrumb from './../../components/BreadCrumb';
import ServiceComponent from './../../components/ServiceComponent';
import HeadingDetailsSection from './../../sections/HeadingDetailsSection';
import { faShieldAlt, faGlobe, faClipboardCheck } from '@fortawesome/free-solid-svg-icons';
import image from './../../assets/pexels/data.jpg';

function DataPrivacyProtectionScreen() {
  return (
    <>
        <HeadingDetailsSection heading='Data Privacy & Protection'>
          <Breadcrumb parent="Services" screen='Data Privacy & Protection'/>
        </HeadingDetailsSection>
        <ServiceComponent
          heading="Data Privacy & Protection"
          description="Safeguard your business and customer data with PocketLPO’s Data Privacy & Protection services. We provide robust solutions to help you comply with global privacy laws and respond to data breaches effectively."
          services={[
            "Privacy audits and compliance assessments.",
            "Data breach response planning and implementation.",
            "GDPR, CCPA, and HIPAA compliance support."
          ]}
          benefits={[
            { title: "Enhanced Security", description: "Protect sensitive information from breaches.", icon: faShieldAlt },
            { title: "Global Compliance", description: "Meet international privacy standards.", icon: faGlobe },
            { title: "Proactive Planning", description: "Minimize risks with comprehensive audits.", icon: faClipboardCheck }
          ]}
          image={image}
        />
    </>
  );
}

export default DataPrivacyProtectionScreen;
